// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessMining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.474 5.194a62.327 62.327 0 0 1 2.574-1.693c-1.202-.018-2.5.133-3.709.559zM6.032 2.972c2.018-.925 4.266-1.076 6.082-.918.553.049.942.434 1.069.875.128.444 0 1.003-.498 1.315-1.528.957-2.656 1.677-3.565 2.331a1.66 1.66 0 0 1-.488 1.145l-.248.25 4.02 4.02 1.08-1.081-1.6-1.6a1.25 1.25 0 0 1 0-1.768l3.89-3.89a3.75 3.75 0 0 1 5.303 0l.706.708a3.75 3.75 0 0 1 0 5.303l-3.889 3.889a1.25 1.25 0 0 1-1.767 0l-1.228-1.228-1.081 1.08 6.632 6.633a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0l-6.632-6.632-6.537 6.536c-.178.179-.481.165-.677-.03l-.707-.707c-.195-.195-.209-.498-.03-.677l6.536-6.537-4.02-4.02-.297.298a1.66 1.66 0 0 1-1.127.487c-.656.919-1.382 2.057-2.344 3.595a1.145 1.145 0 0 1-1.275.505 1.182 1.182 0 0 1-.87-1.042c-.157-1.634-.02-4.005.886-6.097a1.673 1.673 0 0 1 .365-1.813l1.96-1.96a1.672 1.672 0 0 1 1.765-.384zM3.05 8.427c-.406 1.219-.555 2.518-.551 3.632a64.72 64.72 0 0 1 1.657-2.525zm2.307.186a.18.18 0 0 0 .253.007l1.96-1.96a.18.18 0 0 0-.007-.254L5.582 4.424a.18.18 0 0 0-.254-.008l-1.96 1.961a.18.18 0 0 0 .007.254zm15.365-.012a2.25 2.25 0 0 0 0-3.182l-.707-.707a2.25 2.25 0 0 0-3.182 0l-3.712 3.713 1.538 1.538 1.238-.94c.259-.196.587-.2.777-.01l.119.119c.19.19.185.518-.01.777l-.94 1.238 1.167 1.167z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessMining;
